// utilities
import './includes/anchor_links';
// import './includes/overlay';
import './includes/hamburger_nav';

// import './includes/i18n';
// import './includes/searchbox';

// web components 
// import './components/tix02Toggle'; // input checkbox... but toggle ux
// import './components/tix02Notification'; // notif like growl


//import ContentCarousel from './classes/ContentCarousel';
import ScrollBreakpoint from './classes/ScrollBreakpoint';

/*
(function() {
	const carousels = Array.from(document.querySelectorAll('.contents-carousel'));
	carousels.forEach(c => new ContentCarousel(c), {
		bulletsNavClassName: '',
		bulletClassName: '',
		bulletActiveClassName: '',
	});
})();
*/


/*
 * Scrolling breakpoints 
 */
(function() {
	const breakPoints = [];
	/*
		{ 
			breakpoint: 250,
			callBack: {
				UP: element => {
					//document.querySelector('.site-top-bar').classList.remove('min');
					document.querySelector('body').classList.remove('scrolled-down');
				},
				
				DOWN: element => {
					//document.querySelector('.site-top-bar').classList.add('min');
					document.querySelector('body').classList.add('scrolled-down');
				}
			}
		},
	];
	*/
	
	const scrollBP = new ScrollBreakpoint(breakPoints);
	
	scrollBP.addBreakpoint({ 
		breakpoint: document.querySelectorAll('.fade-in'),
		callBack: {
			DOWN: function() {
				this.element.classList.add('shown');
			}
		}
	});	
})();


